import React from 'react'
import { Modal } from 'react-bootstrap/lib'

const DeleteClientModal = ({ deleteClient, client = {}, show, display }) => (
    <Modal show={ show } onHide={ display }>
        <Modal.Header closeButton={ true }>
            <Modal.Title>Delete client.</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className='row'>
                <div className='col-md-12'>
                   Are you sure you want to <strong>delete this client</strong>?
                    <div className='well m-t-12 m-b-4'>
                        { client.name }
                    </div> 
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <a className='btn btn-default' onClick={ display }>
                Cancel
            </a>
            <button name='submit-login' type='submit' className='btn btn-danger' onClick={ deleteClient }>
                Supprimer
            </button>
        </Modal.Footer>
    </Modal>
)

export default DeleteClientModal


// WEBPACK FOOTER //
// ./src/client/features/client/components/DeleteClientModal.jsx